<template>
    <div class="totallAnalysis">
        <div class="totallAnalysis_change">
            <div class="totallAnalysis_change_label">日期</div>
            <el-radio-group v-model="radio" @change="timeRadioGroup">
                <el-radio-button label="1">总</el-radio-button>
                <el-radio-button label="2">今</el-radio-button>
                <el-radio-button label="3">周</el-radio-button>
                <el-radio-button label="4">月</el-radio-button>
            </el-radio-group>
            <el-date-picker
                v-model="timeRange"
                type="datetimerange"
                start-placeholder="开始时间"
                end-placeholder="截止时间"
                value-format="YYYY-MM-DD HH:mm:ss"
                range-separator="至"
            />
        </div>
        <div class="totallAnalysis_wtfl">
            <div class="totallAnalysis_title">
                <p>问题分类top10</p>
                <img src="../../assets/images/echartsDownload.png" alt="">
            </div>
            <div id="echarts_wtfl">

            </div>
        </div>
        <div class="totallAnalysis_scgl">
            <div class="totallAnalysis_scgl_ejfl">
                <div class="totallAnalysis_title">
                    <p>{{ejflEchartsName}}问题top5二级分类</p>
                </div>
                <div id="totallAnalysis_scgl_ejfl">

                </div>
            </div>
            <div class="totallAnalysis_scgl_ejfl">
                <div class="totallAnalysis_title">
                    <p>{{ejflEchartsName}}问题主要承办单位</p>
                </div>
                <div id="totallAnalysis_scgl_cbdw">

                </div>
            </div>
        </div>
        <div class="totallAnalysis_table">
            <div class="totallAnalysis_title">
                <p>问题分类top10</p>
                <img src="../../assets/images/echartsDownload.png" alt="">
            </div>
            <el-table :data="tableData">
                <el-table-column type="index" label="序号" align="center" width="60"/>
                <el-table-column prop="name" label="一类问题分类" min-width="20%"/>
                <el-table-column sortable prop="value" label="总量" min-width="20%"/>
                <el-table-column sortable prop="percent" label="占比" min-width="20%"/>
                <el-table-column label="高频二级分类（前三）" min-width="40%">
                    <template #default="scope">
                        <div v-for="(item,index) in scope.row.gpejfl" style="display:inline-block">
                            {{item.name}}
                            <span style="padding:0 5px;" v-show="(scope.row.gpejfl.length-1) != index">/</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {reactive, ref, watch, onMounted, getCurrentInstance,onUnmounted} from 'vue'
    import * as echarts from 'echarts'

    export default {
        name: "TotallAnalysis",
        setup() {
            const {proxy} = getCurrentInstance();
            const radio = ref()
            const timeRange = ref();
            let wtflEchartsDom;//问题分类
            let ejflEchartsDom;//二级分类
            let ejflEchartsName=ref();
            let cbdwEchartsDom;//承办单位
            let echartsRem = document.documentElement.clientWidth / 1920;
            const wtflEcharts = (id, dataX, data, fontColor, colorStar, colorEnd) => {
                let myChart = echarts.init(document.getElementById(id));
                myChart.setOption({
                    grid: {
                        left: 40*echartsRem,
                        right: 0,
                        bottom: 40*echartsRem,
                        top: 30*echartsRem
                    },
                    xAxis: {
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            margin: 14*echartsRem,
                            fontSize: 12*echartsRem,
                            lineHeight: 14*echartsRem,
                            color: "#333333"
                        },
                        data: dataX
                    },
                    yAxis: {
                        splitNumber: 3,
                        max: function (value) {
                            return Math.ceil(value.max * 4 / 3);
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: ['#ccc'],
                                type: 'dashed',
                            }
                        }
                    },
                    series: [{
                        type: 'bar',
                        barWidth: 40*echartsRem, //柱图宽度
                        data: data,
                        label: {
                            show: true,
                            position: "top",
                            formatter: function (param) {
                                return '{a|' + param.data.value + '}' + '\n' + '{b|' + param.data.percent + '%}'
                            },
                            rich: {
                                a: {
                                    color: fontColor,
                                    fontWeight: '700',
                                    fontFamily: 'Microsoft YaHei UI',
                                    fontSize: 14*echartsRem,
                                    lineHeight: 18*echartsRem,
                                    align: "center"
                                },
                                b: {
                                    color: fontColor,
                                    fontFamily: 'Microsoft YaHei UI',
                                    fontSize: 14*echartsRem,
                                    lineHeight: 18*echartsRem,
                                    align: "center"
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                barBorderRadius: [5*echartsRem, 5*echartsRem, 5*echartsRem, 5*echartsRem],
                                color: {
                                    colorStops: [
                                        {offset: 0, color: colorStar},
                                        {offset: 0.8, color: colorEnd},
                                    ],
                                    x: 0,
                                    y: 0,
                                    x2: 1,
                                    y2: 0,
                                    type: 'linear',
                                    global: false,
                                },
                            },
                        },
                    }
                    ]
                })
                return myChart
            }
            const tableData = ref([]);
            const timeRadioGroup = (param) => {
                let today = new Date();
                let oldDate = new Date();
                let beforeTime;
                if (param == 1) {
                    timeRange.value = "";
                    return
                } else if (param == 2) {
                    beforeTime = today;
                } else if (param == 3) {
                    beforeTime = new Date(oldDate.setDate(oldDate.getDate() - 7));
                } else if (param == 4) {
                    beforeTime = new Date(oldDate.setDate(oldDate.getDate() - 30))
                }
                timeRange.value = [String(beforeTime.getFullYear()) + '-' + String((beforeTime.getMonth()+1)< 10 ? '0' + (beforeTime.getMonth()+1) : (beforeTime.getMonth()+1)) + '-' + String(beforeTime.getDate() < 10 ? '0' + beforeTime.getDate() : beforeTime.getDate()) + ' ' + '00:00:00', String(today.getFullYear()) + '-' + String((today.getMonth()+1) < 10 ? '0' + (today.getMonth()+1) : (today.getMonth()+1)) + '-' + String(today.getDate() < 10 ? '0' + today.getDate() : today.getDate()) + ' ' + '23:59:59']
            }
            watch(timeRange, (newVal) => {
                questionClassfyTop10(newVal[0], newVal[1])
                questionClassfyTop10Table(newVal[0], newVal[1])
            })
            //问题分类top10
            const questionClassfyTop10 = (timeStart = "", timeEnd = "") => {
                if(wtflEchartsDom){
                    wtflEchartsDom.dispose()
                }
                proxy.$axios.post("/jgfast/datawayapi/wgsjtj/wtfltj", {
                    "timeStart": timeStart,	//开始时间
                    "timeEnd": timeEnd,
                    "type": "1"
                }).then((res) => {
                    var dataX = [];
                    if(res.value && res.value.wtfl && res.value.wtfl.length>0){
                        res.value.wtfl.map(value => {
                            dataX.push(value.name);
                        })
                        wtflEchartsDom = wtflEcharts("echarts_wtfl",
                            dataX,
                            res.value.wtfl, '#7785FF', '#9CB4FB', '#8D96FF');
                        wtflEchartsDom.on('click', function (params) {
                            ejflEchartsName.value = params.name;
                            scglTop5(params.data.sjlx, timeStart, timeEnd)
                        });
                        ejflEchartsName.value = dataX[0]
                        scglTop5(res.value.wtfl[0] ? res.value.wtfl[0].sjlx ? res.value.wtfl[0].sjlx : "" : "", timeStart, timeEnd)
                    }
                });
            }
            //市场管理问题top5二级分类
            const scglTop5 = (param, timeStart, timeEnd) => {
                if(ejflEchartsDom){
                    ejflEchartsDom.dispose()
                }
                if(cbdwEchartsDom){
                    cbdwEchartsDom.dispose()
                }
                if (param) {
                    proxy.$axios.post("/jgfast/datawayapi/wgsjtj/wtfltj", {
                        "timeStart": timeStart,	//开始时间
                        "timeEnd": timeEnd,
                        "type": "2",
                        "sjlx": param,
                    }).then((res) => {
                        let dataX_top5 = [];
                        let dataX_unit = [];
                        res.value.wtfl.map(value => {
                            dataX_top5.push(value.name);
                        })
                        res.value.zycbdw.map(value => {
                            dataX_unit.push(value.cbdwmc);
                        })
                        ejflEchartsDom = wtflEcharts("totallAnalysis_scgl_ejfl",
                            dataX_top5,
                            res.value.wtfl, '#26C08B', '#82EEC9', '#53C8A0');
                        cbdwEchartsDom = wtflEcharts("totallAnalysis_scgl_cbdw",
                            dataX_unit,
                            res.value.zycbdw, '#FAC032', '#FFAB5E', '#FFCB67')
                    });
                }else{
                    wtflEcharts("totallAnalysis_scgl_ejfl",
                        [],
                        [], '#26C08B', '#82EEC9', '#53C8A0');
                    wtflEcharts("totallAnalysis_scgl_cbdw",
                        [],
                        [], '#FAC032', '#FFAB5E', '#FFCB67')
                }
            }
            //问题分类top表格
            const questionClassfyTop10Table = (timeStart, timeEnd) => {
                proxy.$axios.post("/jgfast/datawayapi/wgsjtj/wtfltj", {
                    "timeStart": timeStart,	//开始时间
                    "timeEnd": timeEnd,
                    "type": "3",
                }).then((res) => {
                    tableData.value = res.value.wtfl;
                })
            }
            onMounted(() => {
                questionClassfyTop10();
                questionClassfyTop10Table();
                window.addEventListener('resize',() => {
                    echartsRem = document.documentElement.clientWidth / 1920;
                    wtflEchartsDom.resize();
                    ejflEchartsDom.resize();
                    cbdwEchartsDom.resize();
                },true);
            })
            onUnmounted(()=>{
                if(wtflEchartsDom){
                    wtflEchartsDom.dispose();
                }
                if(ejflEchartsDom){
                    ejflEchartsDom.dispose();
                }
                if(cbdwEchartsDom){
                    cbdwEchartsDom.dispose();
                }
            })
            return {
                radio,
                timeRange,
                tableData,
                timeRadioGroup,
                ejflEchartsName
            }
        }
    }
</script>

<style scoped>

</style>
